<template>
  <DecoratorState
    :hasTitleOnAdaptive="hasTitleOnAdaptive"
    title="Completed"
    :hasTitle="hasTitle"
    class="state-ready"
    data-test-id="state-completed"
  >
    <template #icon>
      <IconMaterial title="brightness_7" size="16" />
    </template>
  </DecoratorState>
</template>

<script>
  import DecoratorState from '@/uikitProject/decorators/DecoratorState';
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'StateReady',

    components: {
      DecoratorState,
      IconMaterial,
    },

    props: {
      hasTitle: {
        type: Boolean,
        default: true,
      },
      hasTitleOnAdaptive: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .state-ready {
    color: $color-text-success;
  }
</style>
